module.exports = __webpack_public_path__ + "img/en_questionnaireInvestigationBackImg.6846c373.jpg";